import type { Locale } from '@akpl/i18n';
import { useTranslation } from 'react-i18next';

/**
 * `t` typed for both namespaces this app uses. The default-namespace `t` from
 * `useTranslation()` does not type `mobile:` keys, so every screen goes through this hook.
 */
export function useT() {
  return useTranslation(['mobile', 'common']).t;
}

export type T = ReturnType<typeof useT>;

/** The product locale of the active i18next instance, for `pickI18n` / `formatArtists`. */
export function useLocale(): Locale {
  const { i18n } = useTranslation();
  return i18n.language === 'en' ? 'en' : 'es';
}
